import { loc } from "../../../../core/utils"
import React from "react"
import { Col } from "react-bootstrap"

const AddProductButton = ({ isMultiProduct, handleAddProduct }) => {
  if (!isMultiProduct) return null
  return (
    <Col>
      <button type="button" className="add-product" onClick={handleAddProduct}>
        {loc("simulation_button_add_product")}
      </button>
    </Col>
  )
}

export default AddProductButton
